import { gql } from '@apollo/client';

export const fetchPendingInvoicesForInvoiceGroup = gql`
  query fetchPendingInvoicesForInvoiceGroup($id: ID!) {
    invoiceGroup(id: $id) {
      id
      transactionAccountId
      pendingInvoices
    }
  }
`;
